'use es6';

import { useSelector } from 'react-redux';
import { BaseResponsiveSectionToolbar, buildActionsForSection } from './BaseResponsiveSectionToolbar';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.shouldUseCustomSections (optional)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileSectionToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  shouldUseCustomSections
}) => {
  const isPatagoniaSidebarCollapsed = useSelector(getIsPatagoniaSidebarCollapsed);
  const shouldClosePatagoniaSidebar = !isPatagoniaSidebarCollapsed;
  return /*#__PURE__*/_jsx(BaseResponsiveSectionToolbar, {
    active: false,
    actions: buildActionsForSection({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      shouldUseCustomSections,
      shouldClosePatagoniaSidebar
    }),
    responsiveSize: responsiveSize,
    isSectionDropdownStep: false,
    isStaticSection: false
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.shouldUseCustomSections (required)
 */
const MockResponsiveDesktopSectionToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  shouldUseCustomSections
}) => {
  const isInDeveloperMode = useSelector(getIsInDeveloperMode);
  return /*#__PURE__*/_jsx(BaseResponsiveSectionToolbar, {
    active: false,
    actions: buildActionsForSection({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      shouldUseCustomSections,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize,
    isSectionDropdownStep: false,
    isStaticSection: false
  });
};
export { MockResponsiveMobileSectionToolbarToMeasure, MockResponsiveDesktopSectionToolbarToMeasure };